import { __awaiter } from "tslib";
import { BaseService } from "../../base";
export class ModuleFileService extends BaseService() {
    static get entity() {
        return "module_file";
    }
    static get responseName() {
        return "module_file";
    }
    static getUpdateFile(data) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.submit({
                method: "post",
                path: `update_file`,
                data: data,
                config: {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                },
            });
        });
    }
}
